export const state = {
  userInfo: null,
  openId: "",
  code: "",
};
